import { UPDATE_SEARCHTDATA_TATTOANCHODUYET } from "../../actions/DanhSachTatToanChoDuyet/actionTypes";

const initialState = {
  customerName: "",
  status: -1,
  pageIndex: 1,
  pageSize: 25,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchTatToanChoDuyet = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_TATTOANCHODUYET:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchTatToanChoDuyet;
